module.exports = __webpack_public_path__ + "static/media/deviceusestatement.js.0868d7f1.map";